import React, { useEffect, useState } from 'react'
import Api from '../../../../../services/Api'
import { CardImageNavLink, NFTCardImageOverlay } from '../../../components/NFTCard/syled'
import { INFTCardFormatted } from '../../../components/NFTCard/INFTCard'
import { useGetTokenUri } from '../../../../../hooks/useNFTMarketPlace'
import { IDefaultCard } from './IDefaultCard'
import { useGetBaseUri } from '../../../../../hooks/useYetiSwapNFTCollection'
import DefaultCardImage from '../components/DefaultCardImage/DefaultCardImage'
import BaseCard from '../../Base/Card/BaseCard'

export default function DefaultCard(props: INFTCardFormatted) {
  const { tokenId, collection, detailUrl } = props
  const [tokenItem, setTokenItem] = useState<IDefaultCard | null>(null)
  const tokenUri = useGetTokenUri(collection.tokenAddress, tokenId)
  const nftBaseUri = useGetBaseUri()

  const tokenLink = `${detailUrl}/${collection.tokenAddress}/${tokenId}`

  const tokenName = tokenItem ? tokenItem.name : 'Token Name'

  useEffect(() => {
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setTokenItem(tokenResult))
    }
  }, [tokenUri])

  function getImage() {
    return (
      <CardImageNavLink className="link" to={tokenLink}>
        <div className="default-image">
          <DefaultCardImage item={tokenItem} baseURI={nftBaseUri} isCard={true} />
        </div>
        <NFTCardImageOverlay className="image-overlay">Details</NFTCardImageOverlay>
      </CardImageNavLink>
    )
  }

  return (
    <BaseCard tokenName={tokenName} {...props}>
      {getImage()}
    </BaseCard>
  )
}
